import React from 'react';
import NoContent from 'src/components/NoContent';

function Users() {
  return <NoContent />;
}

export default Users;
